import Vue from 'vue';
import Router from 'vue-router';
import Login from '../components/Login'
import ArticleUpload from '../components/ArticleUpload'
import RetailerArticleOverview from '../components/RetailerArticleOverview'
import ManufacturerArticleOverview from '../components/ManufacturerArticleOverview'
import CSVUpload from '../components/CSVUpload'
import Dashboard from '../components/Dashboard'
import ResetPassword from '../components/ResetPassword'
import ManufecturerData from '../components/ManufecturerData'
import Statistics from '../components/Statistics'
import Alert from '../components/Alert'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    // eslint-disable-next-line no-undef
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/articleupload',
            name: 'ArticleUpload',
            component: ArticleUpload
        },
        {
            path: '/myarticlesretailer',
            name: 'RetailerArticleOverview',
            component: RetailerArticleOverview
        },
        {
            path: '/myarticlesmanufacturer',
            name: 'ManufacturerArticleOverview',
            component: ManufacturerArticleOverview
        },
        {
            path: '/csvuplad',
            name: 'CSVUpload',
            component: CSVUpload
        },
        {
            path: '/resetpassword',
            name: 'ResetPassword',
            component: ResetPassword
        },
        {
            path: '/manufecturerdata',
            name: 'ManufecturerData',
            component: ManufecturerData
        },
        {
            path: '/statistics',
            name: 'Statistics',
            component: Statistics
        },
        {
            path: '/alert',
            name: 'Alert',
            component: Alert
        }
    ]
});

export default router;